import { useAppStore } from '../../shared/store/store'
import IPointOfView from '../interfaces/point-of-view.interface'
import styles from '../../styles.module.css'

export function RemovePointOfViewButton({ point }: { point: IPointOfView }) {
  const setPointsOfView = useAppStore((state) => state.setPointsOfView)
  const pointsOfView = useAppStore((state) => state.pointsOfView)
  const onClick = () => {
    setPointsOfView(pointsOfView.filter((pov) => pov !== point))
  }
  return (
    <button className={styles.remove_point_of_interest_button} onClick={() => onClick()}>
      <p className={styles.remove_point_of_interest_button_text}>-</p>
    </button>
  )
}
